import React from 'react';
import { useCart, useDispatchCart } from '../components/ContextReducer';
import {Trash} from 'react-bootstrap-icons';
import {BASE_URL} from './helper'

export default function Cart() {

    const data = useCart();
    const dispatch = useDispatchCart();
    if (data.length === 0) {
        return(
            <div>
                <div className='m-5 w-100 text-center fs-3' style={{color:"white"}}> The Cart is Empty</div>
            </div>
        )
    }
    const handleCheckOut = async () => {
        let userEmail = localStorage.getItem("userEmail");
        // console.log(data,localStorage.getItem("userEmail"),new Date())
        let response = await fetch(`${BASE_URL}/api/orderData`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            order_data: data,
            email: userEmail,
            order_date: new Date().toDateString()
          })
        });
        console.log("JSON RESPONSE:::::", response.status)
        if (response.status === 200) {
          dispatch({ type: "DROP" })
        }
      }
    const totalPrice = data.reduce((total, food) => total + food.price, 0)

    return (
        <div>
            <div className='container m-auto mt-5 table-responsive table-responsive-lg table-responsive-sm table-responsive-md' style={{color:"white"}}>
                <table class="table table-hover">
                    <thead className='text-success fs-4'>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Name</th>
                            <th scope="col">Quantity</th>
                            <th scope="col">Option</th>
                            <th scope="col">Amount</th>
                            <th scope="col">Delet</th>
                        </tr>
                    </thead>
                    <tbody className='table-body' style={{color:"white"}}>
                    {data.map((food, index) => (
                        <tr>
                            <th scope="row">{index + 1}</th>
                            <td>{food.name}</td>
                            <td>{food.qty}</td>
                            <td>{food.size}</td>
                            <td>{food.price}</td>
                            <td style={{display: 'none'}}>{food.img}</td>
                            <td ><button type="button" className="btn p-0"><Trash style={{color: "white"}} onClick={() => { dispatch({ type: "REMOVE", index: index }) }} /></button> </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                <div>
                    <h1 className='fs-2'>Total Price: {totalPrice}/-</h1>
                </div>
                <div>
                    <button className='btn bg-success mt-5' onClick={handleCheckOut} >Check Out</button>
                </div>

            </div>
        </div>
    )
}

